if ( typeof ProductImageZoom !== 'function' ) {
	class ProductImageZoom extends HTMLElement {

		constructor(){

			super();

			if ( ! document.getElementById('zoom') ) {
				this.zoom = document.createElement('div');
				this.zoom.id = 'zoom';
				this.zoom.innerHTML = `
					<img />
					<span class="zoom__exit">${KROWN.settings.symbols.zoom_out}</span>
					<span class="zoom__loader">${KROWN.settings.symbols.zoom_loader}</span>
					<div class="zoom__overlay"></div>
					<button type="button" class="zoom__nav zoom__nav--prev" aria-label="${window.KROWN?.settings?.locales?.slider_prev_button_label || 'Previous image'}">
						<span aria-hidden="true">‹</span>
					</button>
					<button type="button" class="zoom__nav zoom__nav--next" aria-label="${window.KROWN?.settings?.locales?.slider_next_button_label || 'Next image'}">
						<span aria-hidden="true">›</span>
					</button>
				`;
				document.body.append(this.zoom);
				this.zoom.querySelector('.zoom__exit').addEventListener('click', this._productZoomUnmount.bind(this));
				this.zoom.querySelector('.zoom__nav--prev').addEventListener('click', () => ProductImageZoom.navigate(-1));
				this.zoom.querySelector('.zoom__nav--next').addEventListener('click', () => ProductImageZoom.navigate(1));
			} else {
				this.zoom = document.getElementById('zoom');
			}

			this.prevButton = this.zoom.querySelector('.zoom__nav--prev');
			this.nextButton = this.zoom.querySelector('.zoom__nav--next');

			this.onMouseMoveHandlerBinded = this.onMouseMoveHandler.bind(this);
			this.onResizeHandlerBinded = this.onResizeHandler.bind(this);

			this.addEventListener('click', (e)=>{
				const group = this._collectZoomGroup();
				const startIndex = group.indexOf(this);
				ProductImageZoom.setActive(this, group, startIndex);
				this._toggleNavButtons(group.length > 1);
				this._openZoomAtIndex(startIndex);
			});

		}

		onMouseMoveHandler(e){
			window.clientX = e.clientX;
			window.clientY = e.clientY;
			const x = e.clientX * ( window.innerWidth - this.image.offsetWidth ) / window.innerWidth;
			const y = e.clientY * ( window.innerHeight - this.image.offsetHeight ) / window.innerHeight;
			this.image.style.left = x + 'px';
			this.image.style.top = y + 'px';
		}

		onResizeHandler(){

			if ( !this.image ) {
				return;
			}

			const ratio = parseFloat(this.image.dataset.ratio || 1);
			const viewportMaxWidth = window.innerWidth * 0.9;
			const viewportMaxHeight = window.innerHeight * 0.9;

			let width = viewportMaxWidth;
			let height = width / ratio;

			if ( height > viewportMaxHeight ) {
				height = viewportMaxHeight;
				width = height * ratio;
			}

			this.image.style.width = width + 'px';
			this.image.style.height = height + 'px';

			this.image.style.left = '50%';
			this.image.style.top = '50%';
			this.image.style.transform = 'translate(-50%, -50%)';

		}

		_productZoomMount(image) {

			this.image.style.left = 0;
			this.image.style.top = 0;

			this.image.dataset.ratio = this.image.naturalWidth / this.image.naturalHeight;
			window.addEventListener('resize', this.onResizeHandlerBinded, {passive:true});
			this.onResizeHandler();

			setTimeout(()=>{
				this.zoom.classList.add('loaded');
			}, 50);

		}

		_productZoomUnmount() {

			this.zoom.classList.remove('opened');

			setTimeout(()=>{
				window.removeEventListener('resize', this.onResizeHandlerBinded);
				window.removeEventListener('mousemove', this.onMouseMoveHandlerBinded);
				const image = document.querySelector('#zoom img');
				image.src = '';
				image.className = '';
				image.style = '';
				this.zoom.classList.remove('loaded');
			}, 300);

		}

		_collectZoomGroup(){
			const gallery = this.closest('[data-js-product-gallery]');
			const scope = gallery || document;
			return Array.from(scope.querySelectorAll('product-image-zoom')).filter((item)=>item.getAttribute('data-image'));
		}

		_openZoomAtIndex(index){
			const group = ProductImageZoom.activeGroup || [];
			const target = group[index];
			if ( !target ) {
				return;
			}
			ProductImageZoom.activeIndex = index;
			this.zoom.classList.add('opened');
			this.image = this.zoom.querySelector('img');
			this.zoom.classList.remove('loaded');
			this.image.className = '';
			this.image.style = '';
			this.image.src = target.getAttribute('data-image');
			if ( this.image.complete && this.image.naturalWidth > 0 ) {
				this._productZoomMount();
			} else {
				if ( this._pendingImageLoad ) {
					this.image.removeEventListener('load', this._pendingImageLoad);
				}
				this._pendingImageLoad = ()=>{
					this.image.removeEventListener('load', this._pendingImageLoad);
					this._productZoomMount();
				};
				this.image.addEventListener('load', this._pendingImageLoad);
			}
			this._toggleNavButtons(group.length > 1);
		}

		_toggleNavButtons(shouldShow){
			if ( !this.prevButton || !this.nextButton ) {
				return;
			}
			if ( shouldShow ) {
				this.prevButton.removeAttribute('hidden');
				this.nextButton.removeAttribute('hidden');
			} else {
				this.prevButton.setAttribute('hidden', 'hidden');
				this.nextButton.setAttribute('hidden', 'hidden');
			}
		}

		static setActive(controller, group, index){
			ProductImageZoom.controller = controller;
			ProductImageZoom.activeGroup = group;
			ProductImageZoom.activeIndex = index;
		}

		static navigate(direction){
			if ( !ProductImageZoom.controller || !ProductImageZoom.activeGroup || !ProductImageZoom.activeGroup.length ) {
				return;
			}
			const nextIndex = ProductImageZoom.activeIndex + direction;
			if ( nextIndex < 0 || nextIndex >= ProductImageZoom.activeGroup.length ) {
				return;
			}
			ProductImageZoom.controller._openZoomAtIndex(nextIndex);
		}

	}

  if ( typeof customElements.get('product-image-zoom') == 'undefined' ) {
		customElements.define('product-image-zoom', ProductImageZoom);
	}

}
